/*
 * fl-currency.js — display-only currency conversion.
 *
 * Fairylicense settles in THB (Omise gateway; Shopify Payments isn't available in
 * Thailand). This rewrites the VISIBLE price text into the currency of the visitor's
 * selected country (Shopify Markets country picker) for reference only.
 * Checkout ALWAYS charges THB. A disclaimer is shown whenever a non-THB view is active.
 *
 * Prices must be wrapped via {% render 'fl-money', amount: <cents> %} so they carry
 * data-money-thb. The selected country comes from window.FL_COUNTRY (injected in
 * layout/theme.liquid from localization.country.iso_code).
 *
 * RATES are baked (no network/CORS, converts on first paint). They are approximate
 * reference rates — update the table + ASOF date periodically.
 */
(function () {
  'use strict';

  // 1 THB = X target currency.  asOf 2026-06-09 — reference only.
  var RATES = {
    THB: 1,      USD: 0.0285, EUR: 0.0265, GBP: 0.0225, AUD: 0.0435,
    SGD: 0.0385, JPY: 4.45,   HKD: 0.223,  CNY: 0.207,  IDR: 465,
    CAD: 0.0395, MYR: 0.135,  KRW: 39.5,   TWD: 0.92,   NZD: 0.048,
    AED: 0.1047, INR: 2.45,   VND: 725
  };

  // Country ISO → display currency.  Unmapped country → THB (safe default).
  var COUNTRY_CCY = {
    TH: 'THB', US: 'USD', GB: 'GBP', JP: 'JPY', AU: 'AUD', SG: 'SGD',
    HK: 'HKD', CN: 'CNY', ID: 'IDR', CA: 'CAD', MY: 'MYR', KR: 'KRW',
    TW: 'TWD', NZ: 'NZD', AE: 'AED', IN: 'INR', VN: 'VND',
    DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', IE: 'EUR',
    AT: 'EUR', BE: 'EUR', PT: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR'
  };

  var ZERO_DECIMAL = { JPY: true, KRW: true, IDR: true, TWD: true, VND: true };

  function currencyForCountry(cc) {
    if (!cc) return 'THB';
    var ccy = COUNTRY_CCY[String(cc).toUpperCase()];
    // Only honour it if we actually have a rate for it; else fall back to THB.
    return (ccy && RATES[ccy] != null) ? ccy : 'THB';
  }

  function format(amountCents, ccy) {
    var value = (amountCents / 100) * (RATES[ccy] || 1);
    var frac = ZERO_DECIMAL[ccy] ? 0 : 2;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: ccy,
        minimumFractionDigits: frac, maximumFractionDigits: frac
      }).format(value);
    } catch (e) {
      return ccy + ' ' + value.toFixed(frac);
    }
  }

  var CCY = 'THB';

  function convert(root) {
    var els = (root || document).querySelectorAll('[data-money-thb]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // Remember Shopify's original THB string the first time we touch it.
      if (el.getAttribute('data-money-orig') === null) {
        el.setAttribute('data-money-orig', el.textContent);
      }
      if (CCY === 'THB') {
        el.textContent = el.getAttribute('data-money-orig');
      } else {
        var cents = parseInt(el.getAttribute('data-money-thb'), 10);
        if (!isNaN(cents)) el.textContent = format(cents, CCY);
      }
    }
  }

  function updateLabel() {
    // Dawn renders the selector twice (desktop header + mobile drawer) — update all.
    var labels = document.querySelectorAll('.header__country-label');
    for (var i = 0; i < labels.length; i++) labels[i].textContent = CCY;
  }

  function disclaimer() {
    var notes = document.querySelectorAll('[data-fl-ccy-note]');
    for (var i = 0; i < notes.length; i++) {
      var n = notes[i];
      if (CCY === 'THB') {
        n.hidden = true;
      } else {
        n.textContent = 'Prices shown in ' + CCY +
          ' for reference. You will be charged in Thai Baht (฿) at checkout.';
        n.hidden = false;
      }
    }
  }

  // Re-run when Dawn swaps in re-rendered cart/section HTML (debounced).
  // We disconnect during our own writes — setting textContent is itself a
  // childList mutation and would otherwise retrigger the observer in a loop.
  var mo = null;
  function startObserving() {
    if (mo) mo.observe(document.body, { childList: true, subtree: true });
  }
  function reconvert() {
    if (mo) mo.disconnect();
    convert(document);
    updateLabel();
    disclaimer();
    startObserving();
  }
  function observe() {
    if (!('MutationObserver' in window)) return;
    var t = null;
    mo = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; reconvert(); }, 80);
    });
    startObserving();
  }

  // ── Country resolution.
  // Source of truth is Shopify's selected country (window.FL_COUNTRY) — the native
  // picker sets it (incl. Thailand → THB), so picking a country Just Works and
  // switching back works too. Auto-detect only fills in on a genuine first visit
  // when Shopify still shows the primary (default) country.
  var PRIMARY = 'TH';
  var LAST = 'fl_shop_cc';   // last Shopify country we observed
  var SAVE = 'fl_ccy_country';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // One-time IP geolocation (display only). Fails safe to null → THB.
  function detect(cb) {
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; cb(null); } }, 2500);
    try {
      fetch('https://ipapi.co/country/', { mode: 'cors' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (txt) {
          if (done) return; done = true; clearTimeout(timer);
          var cc = (txt || '').trim().toUpperCase();
          cb(/^[A-Z]{2}$/.test(cc) ? cc : null);
        })
        .catch(function () { if (done) return; done = true; clearTimeout(timer); cb(null); });
    } catch (e) { clearTimeout(timer); cb(null); }
  }

  function resolveCountry(cb) {
    var shop = (window.FL_COUNTRY ? String(window.FL_COUNTRY).toUpperCase() : PRIMARY) || PRIMARY;
    var last = lsGet(LAST);
    lsSet(LAST, shop);

    // Shopify country changed since last load → the visitor used the picker
    // (or was routed). Honour it — including a deliberate switch back to Thailand.
    if (shop !== last) {
      if (last !== null) { lsSet(SAVE, shop); cb(shop); return; }
      // First visit ever:
      if (shop !== PRIMARY) { lsSet(SAVE, shop); cb(shop); return; }
      detect(function (cc) { cc = cc || PRIMARY; lsSet(SAVE, cc); cb(cc); });
      return;
    }
    // Unchanged since last load → reuse the remembered display country.
    cb(lsGet(SAVE) || shop);
  }

  function apply(cc) {
    CCY = currencyForCountry(cc);
    convert(document);
    updateLabel();
    disclaimer();
    observe();
  }

  function init() {
    resolveCountry(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
